import { forwardRef } from 'react'
import { SuffixInput, type SuffixInputProps } from './SuffixInput'
import { formatGermanNumber, parseGermanNumber } from '~/utils/client/helpers/format'

export interface CurrencyInputProps
  extends Omit<SuffixInputProps, 'suffix' | 'formatValue' | 'parseValue'> {}

export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  ({ value, onChange, onBlur, className, ...props }, ref) => {
    return (
      <SuffixInput
        {...props}
        ref={ref}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={className}
        suffix="€"
        formatValue={formatGermanNumber}
        parseValue={parseGermanNumber}
      />
    )
  }
)

CurrencyInput.displayName = 'CurrencyInput'
